const Countdown = () => {
  // Select the countdown container and get the date from the data attribute
  const countdownContainer = document.getElementById('countdown-container');
  const countdownDate = new Date(countdownContainer.dataset.time).getTime();

  // Update the countdown every second
  const countdownFunction = setInterval(() => {
    // Get the current date and time
    const now = new Date().getTime();

    // Find the difference between now and the countdown date
    const distance = countdownDate - now;

    // Calculate days, hours, minutes, and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the respective HTML elements
    document.getElementById('days').textContent = days;
    document.getElementById('hours').textContent = hours;
    document.getElementById('minutes').textContent = minutes;
    document.getElementById('seconds').textContent = seconds;

    // If the countdown is finished, display a message and stop the interval
    if (distance < 0) {
      clearInterval(countdownFunction);
      document.getElementById('countdown-container').style.display = 'none';
    }
  }, 300);
};

export default Countdown;
